/**
 * Runtime Configuration Utility
 * Loads configuration from static /config.json file at runtime.
 */

import { getCachedConfig } from '../services/configService';

/**
 * Detect environment based on current domain.
 */
const detectEnvironmentFromDomain = () => {
  if (typeof window === 'undefined') return 'unknown';

  const hostname = window.location.hostname;

  if (hostname === 'finstacks.natalieandryan.net') {
    return 'prod';
  } else if (hostname === 'dev.natalieandryan.net') {
    return 'dev';
  } else if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local';
  }

  return 'unknown';
};

/**
 * Get runtime configuration.
 * @returns {Object}
 * @throws {Error} if config has not been loaded yet
 */
export const getConfig = () => {
  const runtimeConfig = getCachedConfig();

  if (!runtimeConfig) {
    const error = new Error(
      'Runtime configuration not available. Failed to load configuration from /config.json. ' +
      'Please ensure the application is properly deployed and config.json is accessible.'
    );
    console.error('❌ Configuration Error:', error.message);
    throw error;
  }

  return {
    API_URL: runtimeConfig.apiBaseUrl,
    ENVIRONMENT: detectEnvironmentFromDomain()
  };
};

/**
 * Get API base URL.
 * @returns {string}
 */
export const getApiUrl = () => {
  return getConfig().API_URL;
};

/**
 * Get current environment.
 * @returns {string}
 */
export const getEnvironment = () => {
  return getConfig().ENVIRONMENT;
};

export default {
  getConfig,
  getApiUrl,
  getEnvironment
};
